import React from 'react'
import logolaboratorio from '@/images/logo-laboratorio.svg'

const Footer = () => {
  return (
    <div className="footer bg-black text-white text-center px-10 py-10">
      <img src={logolaboratorio} alt="" className="w-32 mx-auto mb-2" />
      <p className="text-xs leading-tight">
        Desarrollado por el Laboratorio de Contenidos de Marca de La Tercera.
        2020.
      </p>
    </div>
  )
}

export default Footer
